import React, { useState, useEffect } from 'react'
import { Table, Panel } from 'rsuite'
import { budgetFormat } from '../../../utils/formatterUtil'
import './styles.less'

export default function TotalBudgetWidgets({
  bordered = true,
  collapsible = true,
  defaultExpanded = true,
  shaded = true,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { schema } = props

  return (
    <Panel
      header={schema.header}
      eventKey={0}
      bordered={bordered}
      collapsible={collapsible}
      defaultExpanded={defaultExpanded}
      shaded={shaded}
    >
      <Table autoHeight data={schema.summaryCost}>
        {/* <Column width={250}>
          <HeaderCell></HeaderCell>
          <Cell />
        </Column> */}
        <Column flexGrow={2}>
          <HeaderCell>
            <span>
              <b>หมวดค่าใช้จ่าย</b>
            </span>
          </HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isStong) {
                return (
                  <span>
                    <b>{rowData.list}</b>
                  </span>
                )
              } else return <span>{rowData.list}</span>
            }}
          </Cell>
        </Column>

        <Column flexGrow={1} align="right">
          <HeaderCell>
            <span>
              <b>จำนวนเงิน (บาท)</b>
            </span>
          </HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isStong) {
                return (
                  <span>
                    <b>{budgetFormat(rowData.price)}</b>
                  </span>
                )
              } else return <span>{budgetFormat(rowData.price)}</span>
            }}
          </Cell>
        </Column>
        {/* <Column width={20}>
          <HeaderCell></HeaderCell>
          <Cell />
        </Column> */}
      </Table>
    </Panel>
  )
}
